import { render, staticRenderFns } from "./CompanyOverviewDetails.vue?vue&type=template&id=1da4c3f5&scoped=true&"
import script from "./CompanyOverviewDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyOverviewDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOverviewDetails.vue?vue&type=style&index=0&id=1da4c3f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da4c3f5",
  null
  
)

export default component.exports